import { render, staticRenderFns } from "./Sherlock.vue?vue&type=template&id=0c56bbac&scoped=true&"
import script from "./Sherlock.vue?vue&type=script&lang=js&"
export * from "./Sherlock.vue?vue&type=script&lang=js&"
import style0 from "./Sherlock.vue?vue&type=style&index=0&id=0c56bbac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56bbac",
  null
  
)

export default component.exports